
//#region Imports
//#region Angular
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

//#endregion

//#region Bootstrap
import {
    ModalModule,
    PopoverModule,
    TabsModule,
    TooltipModule,
    BsDropdownModule,
    BsModalRef
} from 'ngx-bootstrap';

import {
    BsDatepickerModule,
    BsDatepickerConfig,
    BsDaterangepickerConfig,
    BsLocaleService
} from 'ngx-bootstrap/datepicker';

import { NgxBootstrapDatePickerConfigService } from '../../../../../assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';

//#endregion

//#region Primeng
import { TableModule } from 'primeng/table';
import {
    TreeModule,
    DragDropModule,
    EditorModule,
    InputMaskModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
    ContextMenuModule,
    ButtonModule,
    PaginatorModule,
    CalendarModule,
    CheckboxModule,
    SelectButtonModule,
    InputSwitchModule,
    CarouselModule
} from 'primeng';
import { DropdownModule } from 'primeng/dropdown';
//#endregion

import { UtilsModule } from "../../../../../shared/utils/utils.module";
//#endregion


//#region Custom
import { SearchAndSelectComponent } from "./search-and-select/search-and-select.component"
import { ImageContainerComponent } from "./image/image-container.component";
import { ImageHightlighterTooltipComponent } from "./image-highlighter/image-highlighter-tooltip.component";
//#endregion


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        ModalModule.forRoot(),

        ModalModule.forRoot(),
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),

        TableModule,
        UtilsModule,
        DropdownModule,
        ButtonModule,
        PaginatorModule,
        AutoCompleteModule,
        ProgressSpinnerModule
    ],
    declarations: [
        SearchAndSelectComponent,
        ImageContainerComponent,
        ImageHightlighterTooltipComponent
    ],
    exports: [
        SearchAndSelectComponent,
        ImageContainerComponent
    ],
    entryComponents: [
    ],
    providers: [
        BsModalRef,
        { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
        { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
        { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale }
    ],
})
export class UblCommonModule { }
